import React from 'react';
import styled from 'styled-components';
import { Image } from '@lt/components';
import type { ImageComponentProps } from '../types';

const ImageComponent = ({
  src,
  fallback,
  title,
  isLazyLoading = false,
  onError,
}: ImageComponentProps) => (
  <>
    <StyledImage
      src={src}
      alt={title}
      fallback={fallback ?? src}
      loading={isLazyLoading ? 'lazy' : 'eager'}
      onError={onError}
    />
    {isLazyLoading && <div className="swiper-lazy-preloader" />}
  </>
);

const StyledImage = styled(Image)`
  margin: auto;
`;

export default ImageComponent;
